import React, { Component } from "react";
import ButtonIcon from "../../../button";
import './report-details.component.css';
import { DataTable } from "../../table/data-table/data-table-component";
import Filter from "../../filter/filter.component";
import {CustomColumns} from "../../modal-popover/custom-columns";
import { StackedBarChart } from "../../graph/bar-graph.component";
import { PieGraph } from "../../graph/pie-chart.component";
import { HorizontalBarGraph } from "../../graph/bar-graph.component";
import { CostLineChartData } from "../../../external/reports/cost-report/line-chart/cost-line-chart.component";
import { LegendComp } from "../../graph/bar-graph.component";
import header from "../../sample-data/header";
import { ListTabButton } from "../../list-tab/list-tab-button.component";
import { Selected_Index } from "../../../../constants/internal-constants";
const secondList={
    Headers:[
        {
         
        }
      ]
};

export class ReportDetails extends Component {

    constructor(props) {
        super(props);
        this.DisplayData=this.DisplayData.bind(this)
        this.DisplaySearhBox=this.DisplaySearhBox.bind(this)
        this.state={
            showChart:false,
            displaySearch:false,
            selectedIndex:"0",  
            selectedTab:"0"        
        }
    }

    DisplayData() {      
       
        this.setState({showChart:!this.state.showChart})
        this.setState({displaySearch:false})
    }

    DisplaySearhBox() {
        this.setState({displaySearch:!this.state.displaySearch})
    }
  
    FilterIndex(tabIndex){    
        if(this.props.haveTotalDetail)   
        {
            this.setState({selectedTab:tabIndex});
        } else {
            this.setState({selectedIndex:tabIndex});
        }
        
    }
    
    render(){   
        return(
            <>
            {
                this.props.haveTotalDetail ? 
                
                <div className="component-container legend-center total-report-circle-component">
                    <div>
                        <h1 className="report-detail-title">{this.props.totalTitle}</h1>                      
                    </div>
                    <ListTabButton listData={this.props.listTabInfo.Tab} selectedIndex={this.props.haveTotalDetail ? this.state.selectedTab : this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
                    <div className="total-report-circle-container">
                        {this.props.columnTwoData.map((data,index)=>(
                            index==this.state.selectedTab ?
                            data.items.map((items,id)=>(
                                <div key={id} className="data-right-item">
                                    <div className="data-right-circle data-circle-text">
                                        <p>{items.total}</p>
                                    </div>
                                    <div className="data-right-circle-data">
                                        <p>{items.description}</p>  
                                    </div>                                      
                                </div>
                            ))
                            :
                            null
                        ))} 
                    </div>   
                </div>
                
                : null
            }
            
            <div className="component-container legend-center second-col-container data-table"> 
                    {this.props.tabList && !this.props.haveTotalDetail ? 
                         <div>
                            <ListTabButton listData={this.props.listTabInfo.Tab} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
                            
                          </div> 
                    :
                    
                    null} 
                                           
                <div className="container-header-report-detail">                                     
                    <div>
                        <h1 className="report-detail-title">{this.props.reportTitle}</h1>                      
                    </div>
                        
                    <div className="container-filter-button">
                        <ButtonIcon onClick={this.DisplaySearhBox} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-filter-button" labelName="Search"/>                       
                        <CustomColumns firstList={header.Headers} secondList={secondList.Headers}/>                         
                        <div className="report-detail-separator"></div>
                        <ButtonIcon onClick={this.DisplayData} iconLeft="eye" iconSize="17px" customClassName="header-filter-button" labelName={!this.state.showChart ? "Chart View" : "Table View" }/>
                        <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-down" iconSize="17px" customClassName="header-filter-button" labelName="Extract List"/>
                    </div>                  
                </div>
                {
                    !this.state.showChart ?

                    this.props.dataTable.map((item, id) =>
                        id==this.state.selectedIndex ?
                            <div key={id} className={`${this.props.haveColumnTwo ? "data-two-column" : ""}`}>
                                <div key={id}>
                                     <DataTable showSearchBox={this.state.displaySearch} key={id} id={id} item={item} header={item.HeaderItem} data={item.dataItem} isDataLoaded={true} customClassName="table-container report-details" pages={this.props.pages} havePagination={true} />
                                </div>
                               {this.props.haveColumnTwo ?                                    
                                    this.props.columnTwoData.map((data,id)=>(
                                        <div key={id} className="data-right-column">
                                            <div className="data-right-title"> 
                                                <h1>{data.HeaderItem.title}</h1>
                                                <p>{data.HeaderItem.subTitle}</p>
                                            </div>
                                            <div className="data-right-circle-container">
                                            {data.items.map((items,id)=>(
                                                <div key={id} className="data-right-item">
                                                    <div className="data-right-circle data-circle-text">
                                                        <p>{items.total}</p>
                                                    </div>
                                                    <div className="data-right-circle-data">
                                                        <p>{items.description}</p>  
                                                    </div>                                      
                                                </div>
                                            ))}                                                                                       
                                            </div>
                                        </div>                                        
                                    ))
                                : null}
                           </div>
                        :
                        null
                    )
                    :
                    <div className="chart-report-container">

                            <div className="bar-chart-container">
                                <h1>{this.props.barChartTitle}</h1>
                                <div className="bar-chart-inner-container">
                                    <LegendComp data={this.props.barData} />
                                    <StackedBarChart data={this.props.barChart} barData={this.props.barData} displayLegend={true} legendData={this.props.barData}/>
                                </div>
                                
                            </div>
                        
                        <div className="pie-chart-container">
                                <h1>{this.props.pieChartTitle}</h1>
                                <div className="pie-chart-inner-container">
                                <LegendComp data={this.props.pieData} />
                                <PieGraph data={this.props.pieChart} displayLegend={true} legendData={this.props.pieData}/> 
                                </div>                            
                        </div>
                            
                            <div className="horizontal-chart-container">
                                <h1>{this.props.horizontalTitle}</h1>
                                <div className="horizontal-chart-inner-container">
                                <HorizontalBarGraph data={this.props.horizontalChart} fill="#0071cc" withMargin={true} /> 
                                </div>                            
                            </div>
                            
                            <div className="horizontal-chart-container">
                                <h1>{this.props.horizontalTitles}</h1>
                                <div className="horizontal-chart-inner-container">
                                <HorizontalBarGraph data={this.props.horizontalCharts} fill="#a100ff" withMargin={true} />
                                </div>
                            </div>
                        
                            <div className="line-chart-container">
                                <h1>{this.props.costLineTitle}</h1>
                                <div className="line-chart-inner-container">
                                    <CostLineChartData data={this.props.region} lineColor={"#ff7f0e"} />
                                </div>
                            </div>
                        </div>
                        }
            
            </div>
            </>
        );
    }
}